export default __webpack_public_path__ + "locales/pt-BR/Webhooks.json?hash=3f9c14cda8c561ecca062347eaae021c";